
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/term-conditions",
      function () {
        return require("private-next-pages/term-conditions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/term-conditions"])
      });
    }
  